module.exports = __webpack_public_path__ + "static/RTR_WP-1-Programming-Reduced-967b823ee31bd840d4a879f8a7ec896b.pdf";